import { createMuiTheme } from '@material-ui/core/styles';
import { defaultSecondaryColors } from './constants';

const primary = '#2A2A2A';
const secondary = '#F47D2D';
const error = '#EF3535';

export const buildTheme = (primaryColor: string = primary, secondaryColor: string = secondary) => {
  return createMuiTheme({
    typography: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeightRegular: 500,
    },
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: secondaryColor,
      },
      error: {
        main: error,
      },
      tonalOffset: 0.22,
      contrastThreshold: 1.5,
    },
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
            backgroundColor: secondaryColor,
        },
      },
      MuiPickersDay: {
        daySelected: {
            backgroundColor: secondaryColor,
        },
      },
      MuiCssBaseline: {
        '@global': {
          body: {
            backgroundColor: primaryColor,
            fontWeight: 500,
          },
        },
      },
    } as any,
  });
};
export default buildTheme(primary, secondary);
